module.exports = __webpack_public_path__ + "img/oem_logo_1102.50826199.png";